import { ModalServiceInterface } from './service.interface';
import { ModalViewFactory } from '../../module/modal/view.factory';

const modalService = ModalViewFactory();

const element = <HTMLElement>document.querySelector('[data-qs="modal"]');

if (element) {
  modalService.initialize({
    element: element,
  });

  modalService.render();
}

export function ModalService(): ModalServiceInterface {
  return modalService;
}
